export default __webpack_public_path__ + "static/media/benefit_2.398bcb34.png";